/* eslint-disable react-hooks/exhaustive-deps */
import SyncIcon from "@mui/icons-material/Sync";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  IconButton,
} from "@mui/material";
import { useEffect, useState } from "react";

import DefaultApiService from "../../../../infrastructure/api/default";
import useGetPageInfo from "../../../common/hooks/useGetPageInfo";
import CustomMap from "../../../components/map/CustomMap";
import toMapMarkerData from "../../../components/map/mapMarkerUtils";
import BreadcrumbsComponent from "../../../components/shared/breadcrumbs";
import DropdownPicker from "../../../components/shared/dropdown";

const MapPage = () => {
  const pageInfo = useGetPageInfo();
  const [data, setData] = useState({
    list: [],
    config: {
      center: [32.68, 51.68],
      zoom: 9,
      mapServiceKind: "Default",
    },
  });

  const [loading, setLoading] = useState(false);
  const [filterValues, setFilterValues] = useState({
    tileKind: "neshanMapUrl",
  });

  useEffect(() => {
    if (data.list.length === 0) onGetDataByFilter();
  }, []);

  const onGetDataByFilter = async (params) => {
    setLoading(true);
    const res = await DefaultApiService.getApi("GV/Map/GetData", params);
    // console.log("res", res);
    setLoading(false);
    setData(res.data);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={pageInfo.title}
            action={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                <IconButton
                  variant="text"
                  color="primary"
                  onClick={() => onGetDataByFilter(filterValues)}
                >
                  <SyncIcon />
                </IconButton>
              </Box>
            }
          />
          <CardContent>
            <Grid container>
              <Grid
                container
                item
                xs={12}
                md={12}
                className="filter-bar"
                sx={{ mb: 2 }}
              >
                <Grid item container xs={12} md={12} spacing={2}>
                  <Grid item xs={12} md={4} lg={2}>
                    <DropdownPicker
                      label="نوع نقشه"
                      value={filterValues.tileKind}
                      onChange={(event) => {
                        const value = event.target.value;
                        setFilterValues((old) => ({
                          ...old,
                          tileKind: value,
                        }));
                      }}
                      list={[
                        { value: "neshanMapUrl", name: "نشان" },
                        { value: "neshanSatelliteUrl", name: "ماهواره" },
                        { value: "googleMapUrl", name: "سفارشی (قدیمی)" },
                        { value: "googleEarthUrl", name: "زمین (قدیمی)" },
                      ]}
                      size="small"
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} md={12} sx={{ position: "relative" }}>
                <CustomMap
                  {...data.config}
                  loading={loading}
                  markers={toMapMarkerData(data.list)}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default MapPage;
